import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export const Inpatient = () => {
  const features = ['Цілодобовий медичний нагляд', 'Комфортні 1-2 місні палати', 'Повноцінне збалансоване харчування', 'Повна ізоляція від звичного середовища', 'Апаратна детоксикація', 'Психологічна підтримка'];
  return <section className="py-24 bg-white border-t border-gray-200" data-id="element-171">
      <div className="container mx-auto px-4 md:px-6" data-id="element-172">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-173">
          <FadeIn direction="right" className="order-2 lg:order-1 relative h-[500px] bg-gray-100 border border-gray-200 flex items-center justify-center" data-id="element-174">
            <span className="text-gray-400 font-medium text-lg" data-id="element-175">
              Місце для фото
            </span>
            <div className="absolute inset-0 border border-black/10 m-4 pointer-events-none" data-id="element-176" />
          </FadeIn>

          <div className="order-1 lg:order-2" data-id="element-177">
            <FadeIn data-id="element-178">
              <div className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-4" data-id="element-179">
                Умови перебування
              </div>
              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-180">
                Сучасний стаціонар
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-181">
                Лікування в стаціонарі — це найефективніший та найбезпечніший
                спосіб подолати залежність. Ми створили умови, в яких пацієнт
                відчуває себе комфортно та захищено.
              </p>

              <ul className="space-y-4 mb-10" data-id="element-182">
                {features.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-gray-800" data-id="element-183">
                    <CheckCircle2 className="w-5 h-5 text-gray-400 flex-shrink-0" strokeWidth={1.5} data-id="element-184" />
                    <span data-id="element-185">{feature}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};